import React, { useState } from 'react';
import { FaFileAlt } from "@react-icons/all-files/fa/FaFileAlt";
import { FaFolderOpen } from "@react-icons/all-files/fa/FaFolderOpen";
import { FaFolder } from "@react-icons/all-files/fa/FaFolder";


interface FileNode {
  id: string;
  name: string;
  type: 'folder' | 'file';
  children?: FileNode[];
}

const sampleData: FileNode[] = [
  {
    id: '1',
    name: 'Documents',
    type: 'folder',
    children: [
      { id: '2', name: 'Resume.docx', type: 'file' },
      { id: '3', name: 'Report.pdf', type: 'file' },
      {
        id: '4',
        name: 'Projects',
        type: 'folder',
        children: [
          { id: '5', name: 'App.js', type: 'file' },
          { id: '6', name: 'style.css', type: 'file' },
        ],
      },
    ],
  },
  {
    id: '7',
    name: 'Pictures',
    type: 'folder',
    children: [
      { id: '8', name: 'vacation.jpg', type: 'file' },
      { id: '9', name: 'family.png', type: 'file' },
    ],
  },
];

const FileExplorer: React.FC = () => {
  const [currentPath, setCurrentPath] = useState<FileNode[]>(sampleData);
  const [breadcrumbs, setBreadcrumbs] = useState<FileNode[]>([]);

  const openFolder = (folder: FileNode) => {
    if (folder.type === 'folder' && folder.children) {
      setBreadcrumbs([...breadcrumbs, folder]);
      setCurrentPath(folder.children);
    }
  };

  const goBack = (index: number) => {
    const newBreadcrumbs = breadcrumbs.slice(0, index + 1);
    const last = newBreadcrumbs[newBreadcrumbs.length - 1];
    setBreadcrumbs(newBreadcrumbs);
    setCurrentPath(last.children || sampleData);
  };

  const goRoot = () => {
    setBreadcrumbs([]);
    setCurrentPath(sampleData);
  };

  return (
    <div style={{ padding: '1rem', fontFamily: 'sans-serif' }}>
      {/* Breadcrumbs */}
      <div style={{ marginBottom: '1rem', display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <span style={{ cursor: 'pointer', color: '#007bff' }} onClick={goRoot}>
          Profase
        </span>
        {breadcrumbs.map((crumb, index) => (
          <span key={crumb.id} style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            ›
            <span
              style={{ cursor: 'pointer', color: '#007bff' }}
              onClick={() => goBack(index)}
            >
              {crumb.name}
            </span>
          </span>
        ))}
      </div>

      {/* Grid de archivos */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
          gap: '1.5rem',
        }}
      >
        {currentPath.map(node => (
          <div
            key={node.id}
            style={{
              textAlign: 'center',
              cursor: node.type === 'folder' ? 'pointer' : 'default',
            }}
            onDoubleClick={() => openFolder(node)}
          >
            <div
              style={{
                fontSize: '48px',
                marginBottom: '0.5rem',
              }}
            >
              {node.type === 'folder' ? (
                <FaFolder color="#f0ad4e" />
              ) : (
                <FaFileAlt color="#5bc0de" />
              )}
            </div>
            <div style={{ fontSize: '14px', wordBreak: 'break-word' }}>{node.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileExplorer;